const FORM = document.querySelector(".search-box");

if (FORM) {
    const INPUT = FORM.querySelector(".search-field");
    const OPTS  = FORM.querySelectorAll("input[name=selection]");

    OPTS.forEach((opt) => {
        opt.addEventListener("change", () => {
            if (opt.value === "catalog") {
                FORM.setAttribute("target", "_blank");
                FORM.setAttribute("action", "https://discover.rodgerslibrary.org/Union/Search");
                INPUT.setAttribute("name", "lookfor");
            } else {
                FORM.setAttribute("target", "_self");
                FORM.setAttribute("action", "/search/node");
                INPUT.setAttribute("name", "keys");
            }
        });
    });
}
